

























































































































import { Vue, Component } from "vue-property-decorator";
@Component
export default class Index extends Vue {
  get imgHeight(): number {
    const screenHeight: number =
      document.documentElement.clientHeight || document.body.clientHeight;
    const result: number = screenHeight * (420 / 1080);
    console.log(result);
    return result;
  }
}
